module.exports = __webpack_public_path__ + "img/9600.79a874ff.jpg";